module.exports = __webpack_public_path__ + "img/eyezen-black.a51c177f.svg";